import { callPost } from '../graphql';
import { FAQ } from '../graphql/query';

export const getFAQv2 = async () => {
    const { data: axiosData } = await callPost(FAQ, {});
    const { data } = axiosData;
    return data.getFAQv2;
};
